import * as React from "react";

const InfoWithBorder = ({ borderColor, color }: { borderColor: string; color: string; size?: string }): JSX.Element => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19.6518 12.001C19.6518 7.77554 16.2264 4.35015 12.001 4.35015C7.77554 4.35015 4.35015 7.77554 4.35015 12.001C4.35015 16.2264 7.77554 19.6518 12.001 19.6518V21.002C7.02987 21.002 3 16.9721 3 12.001C3 7.02987 7.02987 3 12.001 3C16.9721 3 21.002 7.02987 21.002 12.001C21.002 16.9721 16.9721 21.002 12.001 21.002V19.6518C16.2264 19.6518 19.6518 16.2264 19.6518 12.001Z"
                fill={borderColor}
            />
            <path
                d="M11.1006 16.5007V11.1001C11.1006 10.603 11.5036 10.2 12.0007 10.2C12.4978 10.2 12.9008 10.603 12.9008 11.1001V16.5007C12.9008 16.9978 12.4978 17.4008 12.0007 17.4008C11.5036 17.4008 11.1006 16.9978 11.1006 16.5007ZM11.1006 7.49972V7.04967C11.1006 6.55256 11.5036 6.14957 12.0007 6.14957C12.4978 6.14957 12.9008 6.55256 12.9008 7.04967V7.49972C12.9008 7.99683 12.4978 8.39982 12.0007 8.39982C11.5036 8.39982 11.1006 7.99683 11.1006 7.49972Z"
                fill={borderColor}
            />
        </svg>
    );
};
export default InfoWithBorder;
